import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from 'react-native';
import { component } from '../../Decorators/Component';
import { CardView } from '../Cards/CardView';
import { AnimatedScrollView } from '../Common/AnimatedScrollView';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
export const ModalView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.modal,
    style: {
        container: {
            flex: 1,
            backgroundColor: 'rgba(0, 0, 0, 0.3)'
        },
        content: {
            padding: 20,
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100%'
        }
    }
})(({ animationType, visible, children, containerStyle, contentStyle, cardBodyStyle, cardStyle, style }) => {
    return (_jsx(Modal, { animationType: animationType || 'fade', transparent: true, visible: visible, children: _jsx(AnimatedScrollView, { containerStyle: Object.assign(Object.assign({}, style === null || style === void 0 ? void 0 : style.container), containerStyle), contentContainerStyle: Object.assign(Object.assign({}, style === null || style === void 0 ? void 0 : style.content), contentStyle), children: _jsx(CardView, { containerStyles: cardStyle, bodyStyles: cardBodyStyle, children: children }) }) }));
});
